import {takeEvery} from 'redux-saga/effects'
import {SAVE_EXPORT_REQUEST} from 'setup/redux/Actions/DataExport/components/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(SAVE_EXPORT_REQUEST, fetchData)
}

export default dataSaga
